import React from 'react';
import { getMasteryBand } from './masteryBands';
interface MasteryBarProps {
  /** Mastery value 0-100. */
  value: number;
  /** Override the percentage label (e.g. when the bar represents a different metric). */
  hidePercentage?: boolean;
  className?: string;
}
/**
 * Compact mastery bar — 16px wide, 1.5px tall, with percentage label.
 *
 * Uses canonical mastery bands from `masteryBands.ts` (thresholds 75/55/35,
 * colours emerald/indigo/amber/rose) so all portals render the same value
 * with the same colour and same descriptive label.
 *
 * Was previously forked in `portals/admin/shared/MasteryBar.tsx` with
 * different thresholds (80/60/40) and colours (emerald/amber/orange/red),
 * causing cross-portal inconsistency. Promoted per
 * ADMIN_DOMAIN_RC_AUDIT_2026 §19.4 P1-4.
 */
export function MasteryBar({
  value,
  hidePercentage = false,
  className = ''
}: MasteryBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  const band = getMasteryBand(clamped);
  return <div className={`flex items-center gap-2 ${className}`} role="img" aria-label={`${band.label}, ${Math.round(clamped)} procent`} data-id="element-7663">
      <div className="w-16 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-7664">
        <div className={`h-1.5 rounded-full ${band.barClass}`} style={{
        width: `${clamped}%`
      }} data-id="element-7665" />
      </div>
      {!hidePercentage && <span className="text-xs text-gray-600 tabular-nums" data-id="element-7666">
          {Math.round(clamped)}%
        </span>}
    </div>;
}